import { Label, Select } from 'flowbite-react'
import {
  PLAYER_FILTER_ALL,
  PLAYER_FILTER_NON_PAYING,
  PLAYER_FILTER_PAYING,
  type PlayerFilter,
} from '@constants/exports'

interface PlayerFilterSelectProps {
  value: PlayerFilter
  onChange: (next: PlayerFilter) => void
}

function PlayerFilterSelect({ value, onChange }: PlayerFilterSelectProps) {
  return (
    <div>
      <Label
        className="mb-2 block text-sm font-semibold text-slate-950 dark:text-slate-100"
        htmlFor="player-filter"
      >
        По игрокам
      </Label>
      <Select
        id="player-filter"
        value={String(value)}
        onChange={(event) => onChange(Number(event.target.value) as PlayerFilter)}
      >
        <option value={PLAYER_FILTER_ALL}>Все</option>
        <option value={PLAYER_FILTER_PAYING}>Платящие</option>
        <option value={PLAYER_FILTER_NON_PAYING}>Не платящие</option>
      </Select>
    </div>
  )
}

export default PlayerFilterSelect
